import { render, staticRenderFns } from "./ModalCreateVehicle.vue?vue&type=template&id=3b90a076&scoped=true&"
import script from "./ModalCreateVehicle.vue?vue&type=script&lang=js&"
export * from "./ModalCreateVehicle.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateVehicle.vue?vue&type=style&index=0&id=3b90a076&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b90a076",
  null
  
)

export default component.exports